import { Component, OnDestroy, OnInit, Renderer2, inject } from '@angular/core'
import { AuthService } from '../../../services/auth.service'
import { NavbarMainComponent } from '../navbar-main/navbar-main.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'lg-simple-layout',
    templateUrl: './simple-layout.component.html',
    styleUrls: ['./simple-layout.component.scss'],
    imports: [NavbarMainComponent, RouterOutlet, FooterComponent]
})
export class SimpleLayoutComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);


  ngOnInit(): void {
    this.renderer.addClass(document.body, 'simple-layout')
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'simple-layout')
  }
}
